var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon iconfont",class:_vm.classes,on:{"click":_vm.handleClick}})}
var staticRenderFns = []
export { render, staticRenderFns }